import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { deleteOrganization } from "requesters/organizationRequester"
import SweetAlert from "react-bootstrap-sweetalert"
import AnchorButton from "components/AnchorButton"
import { toast } from "react-toastify"
import { extractApiErrorMessage, MAIN_TOAST_OPTIONS } from "utils/apiErrors"
import { getBaseUrl } from "../../reducers"


export default function OrganizationRow({ organization, onDeleteOrganization, selectedOrganizations, handleRowInputCheck, mergeInfo }) {
  const {
    id, attributes
  } = organization
  const baseUrl = useSelector(getBaseUrl)
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)
  if (attributes) {
    const {
      name,
      email,
      accountTypeLabel,
      address,
      jobServicesCount
    } = attributes

    const handleDelete = () => {
      deleteOrganization(baseUrl, id)
        .then(res => {
          if (res.status === 200) {
            onDeleteOrganization(id)
            setShowDeleteAlert(false)
          } else {
            setShowDeleteAlert(false)
          }
        })
        .catch(err => {
          toast.error(`Could not delete organisation: ${extractApiErrorMessage(err)}`, MAIN_TOAST_OPTIONS)
          setShowDeleteAlert(false)
        })
    }

    const handleNavigateToDetail = () => {
      window.location.href = `/organizations/${id}/edit`
    }

    return (
      <>
        <tr className="cursor-pointer">
          {mergeInfo && <td><input type="checkbox" checked={selectedOrganizations.some(o => o.id === id)} onChange={() => handleRowInputCheck(id)} /></td>}
          <td onClick={handleNavigateToDetail}>{name}</td>
          <td onClick={handleNavigateToDetail}>{email}</td>
          <td onClick={handleNavigateToDetail}>{accountTypeLabel}</td>
          <td onClick={handleNavigateToDetail}>{address}</td>
          <td onClick={handleNavigateToDetail}>{jobServicesCount}</td>
          <td>
            <Link to={`/organizations/${id}/edit`}>Edit</Link>
            {jobServicesCount === 0 && (
              <>
                <span className="text-muted mx-2">|</span>
                <AnchorButton disabled={showDeleteAlert} className="text-danger" type="button" onClick={() => setShowDeleteAlert(true)}>
                  Delete
                </AnchorButton>
              </>
            )}
          </td>
        </tr>
        <SweetAlert
          show={showDeleteAlert}
          type="custom"
          customClass="text-dark"
          title={(
            <>
              Are you sure you want to delete organization
              <span className="ml-1"></span>
              <b>{name}</b>
              ?
            </>
          )}
          confirmBtnText="Delete"
          confirmBtnCssClass="btn btn-danger"
          closeOnClickOutside
          allowEscape={false}
          showCancel
          confirmBtnStyle={{
            border: "none",
            boxShadow: "none"
          }}
          onCancel={() => setShowDeleteAlert(false)}
          onConfirm={() => handleDelete()}>
          <p className="text-muted">
            This action cannot be undone.
          </p>
        </SweetAlert>
      </>
    )
  }
  return null
}
